import $, { css, get } from "jquery";
$(function () {
  const menuHamburger = document.querySelector('.menu-hamburger');
  const menu = document.querySelector('.menu');
  const menuSection = menu.querySelector('.menu-section');
  const menuArrow = menu.querySelector('.menu-mobile-arrow');
  const menuToggle = document.querySelector('.menu-mobile-toggle');
  const menuOverlay = document.querySelector('.overlay');
  let subMenu;

  menuSection.addEventListener('click', (e) => {
    if (!menu.classList.contains('active')) {
      return;
    }
    
    const hasChildren = e.target.closest('.menu-item-has-children');
    if (hasChildren) {
      const arrow = e.target.closest('.arrow-down.has-children');
      if (arrow) {
        showSubMenu(hasChildren);
        e.preventDefault();
      }
    }
  });

  menuArrow.addEventListener('click', () => {
    hideSubMenu();
  });

  menuToggle.addEventListener('click', () => {
    toggleMenu();
  });

  menuOverlay.addEventListener('click', () => {
    toggleMenu();
  });

  function toggleMenu() {
    menu.classList.toggle('active');
    menuHamburger.classList.toggle('open');
    menuOverlay.classList.toggle('active');
    if (menu.classList.contains('active')) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  }

  function showSubMenu(hasChildren) {
    subMenu = hasChildren.querySelector('.menu-subs');
    subMenu.classList.add('active');
    subMenu.style.animation = 'slideLeft 0.5s ease forwards';
    const menuTitle = hasChildren.querySelector('i').parentNode.childNodes[0].textContent;
    menu.querySelector('.menu-mobile-title').innerHTML = menuTitle;
    menu.querySelector('.menu-mobile-header').classList.add('active');
  }

  function hideSubMenu() {
    subMenu.style.animation = 'slideRight 0.5s ease forwards';
    setTimeout(() => {
      subMenu.classList.remove('active');
    }, 300);
    
    menu.querySelector('.menu-mobile-title').innerHTML = '';
    menu.querySelector('.menu-mobile-header').classList.remove('active');
  }

  window.onresize = function () {
    if (this.innerWidth > 1023) {
      if (menu.classList.contains('active')) {
        toggleMenu();
      }
    }
  };
});
